import { render, staticRenderFns } from "./ServicesCell.vue?vue&type=template&id=537108be&scoped=true&"
import script from "./ServicesCell.vue?vue&type=script&lang=js&"
export * from "./ServicesCell.vue?vue&type=script&lang=js&"
import style0 from "./ServicesCell.vue?vue&type=style&index=0&id=537108be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537108be",
  null
  
)

export default component.exports